import {Animate} from '../modules/Animate.js'
/**
 * Toggle Nav
 * ======================================
 * - toggle class on body
 */

const ELEMENTS = '.js-ShowLecturers'
const TOGGLE_CLASS = 'ShowLecturers-is-active'

class ShowLecturers {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)

    if (!this.elements) {
      return false
    }

    this.elements.forEach((el) => {
      el.addEventListener('click', this.toggle, false)
    })
  }

  toggle(e) {
    const el = e.currentTarget;
    const label = el.querySelector('.lecturers__bubble div');
    const currentLabel = label.innerHTML;
    const newLabel = el.getAttribute("data-toggle-label");

    if (newLabel) {
      label.innerHTML = newLabel;
      el.setAttribute("data-toggle-label", currentLabel);
    }

    document.body.classList.toggle(TOGGLE_CLASS)

    new Animate()

    e.preventDefault()
  }
}

new ShowLecturers()
